import { Directive, DoCheck }                                         from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatInput }                                                   from '@angular/material/input';


const _clearValidators                    = AbstractControl.prototype.clearValidators;
AbstractControl.prototype.clearValidators = function() {
  ( this as any ).isRequired = false;
  _clearValidators.call(this);
};

const _setValidators                    = AbstractControl.prototype.setValidators;
AbstractControl.prototype.setValidators = function(newValidator: ValidatorFn | ValidatorFn[] | null): void {
  ( this as any ).isRequired = false;
  _setValidators.call(this, newValidator);
};

export function ReactiveRequired(control: AbstractControl): ValidationErrors | null {
  ( control as any ).isRequired = true;
  return Validators.required(control);
}

@Directive({
  selector: '[redReactiveRequired]'
})
export class ReactiveRequiredDirective implements DoCheck {
  constructor(private readonly input: MatInput) { }

  ngDoCheck() {
    const isRequired = ( this.input.ngControl && this.input.ngControl.control as any ).isRequired || false;

    if (isRequired !== this.input.required) {
      this.input.required = isRequired;
      this.input.ngOnChanges();
    }
  }
}
